import './App.css';
import {useState} from 'react'
import RestrictedPage from './components/RestrictedPage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const user = "Matheus"
  
  function Login(){
    setIsLoggedIn(true)
  }

  function Logout(){
    setIsLoggedIn(false)
  }

  return (
    <div className="App">
        <div className="App-header">
        <RestrictedPage Login={Login} Logout={Logout} user={user} isLoggedIn ={isLoggedIn} />
        </div>
      </div>
    );
  }
  


export default App;
